/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ErrorHeader: {
        id: 'common.error.ErrorHeader',
        defaultMessage: 'Thank you for visiting Saga…'
    },
    SomethingGoneWrong: {
        id: 'common.error.SomethingGoneWrong',
        defaultMessage: 'Sorry, something\'s gone wrong with our website.'
    },
    PleaseCallUs: {
        id: 'common.error.PleaseCallUs',
        defaultMessage: 'Please give us a call on {phoneNumber} to continue with your request.'
    },
    LinesOpen: {
        id: 'common.error.LinesOpen',
        defaultMessage: 'Our lines are open 8.30am to 8pm weekdays, 9am to 5pm Saturday and 9am to 5pm Sunday.'
    },
    LinesOpenTravel: {
        id: 'common.error.LinesOpenTravel',
        defaultMessage: 'Our lines are open 8.30am to 7pm weekdays, and 8.30am to 5pm Saturdays.'
    },
    LinesOpenSmi: {
        id: 'common.error.LinesOpenSmi',
        defaultMessage: 'Our lines are open 8.30am to 7pm weekdays, and 9.00am to 1pm Saturdays.'
    },
    PageUnavailableMessage: {
        id: 'common.error.PageUnavailableMessage',
        defaultMessage: 'We apologise that our website is currently unavailable.'
    },
    ErrorRetrievalBlockedMessage: {
        id: 'common.error.ErrorRetrievalBlockedMessage',
        defaultMessage: 'You have reached the maximum number of attempts for entering your details. Please call us on {phoneNumber} for further assistance.'
    },
    CallUsUnavailable: {
        id: 'common.error.CallUsUnavailable',
        defaultMessage: 'Please call the number below and our customer service advisers will be happy to continue with your request.'
    },
    ErrorHeaderTouched: {
        id: 'common.error.ErrorHeaderTouched',
        defaultMessage: 'Thank you for your interest in Saga\'s Insurance'
    },
    TouchedOfflineMessage: {
        id: 'common.error.TouchedOfflineMessage',
        defaultMessage: 'Sorry, we have been unable to retrieve your quote. If you have any questions or would like to discuss your policy, please call us on {phoneNumber}'
    },
    ErrorHeaderPayment: {
        id: 'common.error.ErrorHeaderPayment',
        defaultMessage: 'Sorry there has been a problem in trying to take payment for your Saga Insurance'
    },
    PurchaseNotComplete: {
        id: 'common.error.PurchaseNotComplete',
        defaultMessage: 'We have not been able to complete your policy purchase.'
    },
    PaymentCallUs: {
        id: 'common.error.PaymentCallUs',
        defaultMessage: 'Please call {phoneNumber} and speak to one of our agents who will be able to help.'
    },
    PaymentProblem: {
        id: 'common.error.PaymentProblem',
        defaultMessage: 'It looks like we\'ve had a problem taking your payment.'
    },
    PaymentTryAgain: {
        id: 'common.error.PaymentTryAgain',
        defaultMessage: 'Your account has not been charged. Please try again by returning to our payment page.'
    },
    PaymentDiscussFurther: {
        id: 'common.error.PaymentDiscussFurther',
        defaultMessage: 'Please contact us on {phoneNumber} to discuss further.'
    },
    PaymentPending: {
        id: 'common.error.PaymentPending',
        defaultMessage: 'Your account will not be charged but it may show as a pending transaction for up to 24 hours.'
    },
    PaymentLinesOpen: {
        id: 'common.error.PaymentLinesOpen',
        defaultMessage: 'Our lines are open:'
    },
    PaymentOpeningTimes: {
        id: 'common.error.PaymentOpeningTimes',
        defaultMessage: '9am to 5pm weekdays'
    },
    ReturnToPayment: {
        id: 'common.error.ReturnToPayment',
        defaultMessage: 'Return to payment'
    },
    HeaderTimeout: {
        id: 'common.error.HeaderTimeout',
        defaultMessage: 'Resume your {productName} insurance quote...'
    },
    HeaderTimeoutQuickQuote: {
        id: 'common.error.HeaderTimeoutQuickQuote',
        defaultMessage: 'Resume your {productName} insurance quick quote...'
    },
    TimeoutMessage1: {
        id: 'common.error.TimeoutMessage1',
        defaultMessage: 'As you have been inactive for a while, to protect your information we have closed your session.'
    },
    TimeoutMessage2: {
        id: 'common.error.TimeoutMessage2',
        defaultMessage: 'To continue with your quote, simply enter your details below and click \'Resume my quote\''
    },
    TimeoutAlternatively1: {
        id: 'common.error.TimeoutAlternatively1',
        defaultMessage: 'Alternatively, you can '
    },
    TimeoutAlternatively2: {
        id: 'common.error.TimeoutAlternatively2',
        defaultMessage: 'start a new quote'
    },
    TimeoutAlternatively3: {
        id: 'common.error.TimeoutAlternatively3',
        defaultMessage: ' or call us on {phoneNumber}'
    },
    TimeoutSurname: {
        id: 'common.error.TimeoutSurname',
        defaultMessage: 'Surname'
    },
    TimeoutPostcode: {
        id: 'common.error.TimeoutPostcode',
        defaultMessage: 'Postcode'
    },
    TimeoutDOB: {
        id: 'common.error.TimeoutDOB',
        defaultMessage: 'Date of Birth'
    },
    TimeoutResume: {
        id: 'common.error.TimeoutResume',
        defaultMessage: 'Resume my quote'
    },
    TimeoutResumeError: {
        id: 'common.error.TimeoutResumeError',
        defaultMessage: 'Sorry, we have been unable to retrieve your quote. Please check your details above, alternatively you can start a '
    },
    TimeoutResumeErrorLink: {
        id: 'common.error.TimeoutResumeErrorLink',
        defaultMessage: 'New quote'
    },
    QuotationErrorMessage: {
        id: 'common.error.QuotationErrorMessage',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to offer you a quotation.'
    },
    WrongUrlHeader: {
        id: 'common.error.WrongUrlHeader',
        defaultMessage: '404 Page Not Found'
    },
    WeCantFind: {
        id: 'common.error.WeCantFind',
        defaultMessage: 'We can\'t find that...'
    },
    LostPage: {
        id: 'common.error.LostPage',
        defaultMessage: 'Sorry, we\'ve lost that page. Let\'s get you where you want to be:'
    },
    GetQuote: {
        id: 'common.error.GetQuote',
        defaultMessage: 'Get a {product} insurance quote'
    },
    FindOutAboutInsurance: {
        id: 'common.error.FindOutAboutInsurance',
        defaultMessage: 'Find out about Saga {product} insurance'
    },
    AllSagaInsurance: {
        id: 'common.error.AllSagaInsurance',
        defaultMessage: 'All Saga insurance'
    },
    NewQuote: {
        id: 'common.error.NewQuote',
        defaultMessage: 'Begin a new quote'
    }
});
